import { LOCAL_STORAGE_AFFILIATE_NAME, getAffiliateFromCurrentUrl } from "./createAffiliateStorageFromParams.js";
import { localStorageTest } from "../utils/localStorageTest.js";
/**
 * Get the affiliate provider with affiliate data. Currently `devowl` and `paddle` (backwards-
 * compatibility) is supported.
 *
 * For backwards compatibility it also reads the paddle affiliate cookie.
 */ function getAffiliateFromStorage() {
    // Read from current URL (e.g. user has not given consent)
    const fromUrl = getAffiliateFromCurrentUrl();
    if (fromUrl) {
        return fromUrl;
    }
    // Read from local storage
    if (localStorageTest()) {
        const lsAffiliateValueString = localStorage.getItem(LOCAL_STORAGE_AFFILIATE_NAME);
        if (lsAffiliateValueString) {
            return JSON.parse(lsAffiliateValueString);
        }
    }
    return undefined;
}
export { getAffiliateFromStorage };
